// extracted by mini-css-extract-plugin
export var active = "_23-9";
export var backButton = "_23-8";
export var clone = "_23-e";
export var collapseBar = "_23-k";
export var collapseMode = "_23-m";
export var collapsed = "_23-o";
export var dimmed = "_23-i";
export var dragHandle = "_23-c";
export var dropdownIcon = "_23-g";
export var expanding = "_23-n";
export var hidden = "_23-x";
export var iconContainer = "_23-q";
export var iconSwapper = "_23-w";
export var navItem = "_23-6";
export var navItemIcon = "_23-f";
export var navProfile = "_23-7";
export var notificationCountBadge = "_23-j";
export var notificationDot = "_23-r";
export var optionsContainer = "_23-h";
export var primaryNav = "_23-0";
export var primaryNavDivider = "_23-v";
export var primaryNavResizeHandle = "_23-2";
export var primaryNavResizing = "_23-1";
export var primaryNavTabSection = "_23-u";
export var primaryTab = "_23-p";
export var primaryTabIconBox = "_23-s";
export var secondaryNav = "_23-3";
export var selected = "_23-t";
export var settingsNav = "_23-4";
export var settingsNavItems = "_23-5";
export var show = "_23-d";
export var sideNav = "_23-l";
export var teamItem = "_23-a";
export var userProfileItem = "_23-b";